import pdfMake from 'pdfmake';
import { BrowserRouter as Router, Route, Routes, Outlet, Navigate } from 'react-router-dom';
import AngularRootApp from './AngularRootApp';
import Popout from './common/components/Popout';
import { doRegistration } from './components/customCtrlRegistrations';
import { createEntities } from './entities/entityRegistrations';
import { useMemo } from 'react';
import { PublicFormGroup } from './components/PublicFormGroup';
import { PublicForm } from './components/PublicForm';
import { ReactResetPassword } from './components/ResetPassword';
import { RequestAccount } from './components/RequestAccount';
import { ReactForgottenPassword } from './components/ForgottenPassword';
import { RequireAuth } from './components/RequireAuth';
import { CAD } from './components/CAD';
import Signin from './common/components/Signin';
import { Settings } from './components/Settings';
import { PublicNavBar, SigninNavBar } from './components/NavBar';
import SitRep from './components/SitRep';
import { CommonComponentContextProvider } from './utils/CommonContextProvider';
import useAppState from './common/hooks/appStateHook';
import { doPopoutRegistration } from './components/popoutCtrlRegistrations';
import { WebsocketProvider } from './common/utils/websocketProvider';
import Stats from './components/stats/Stats';
import { ProductFruits } from './ProductFruits';
import Logout from './common/components/Logout';

const RootContext = () => {
    return <WebsocketProvider interval={400}>
        <CommonComponentContextProvider>
            <ProductFruits>
                <Outlet></Outlet>
            </ProductFruits>
        </CommonComponentContextProvider>
    </WebsocketProvider>
}

const DefaultPath = () => {
    const { token } = useAppState();

    const hash = window.location.hash; // includes the `#!...` part

    // Match the old-style hashbang path and query
    const hashMatch = hash.match(/^#!\/(publicform|publicgroup)\/([^?#]+)(\?[^#]*)?/);

    if (hashMatch) {
        const [, type, code, queryParams = ''] = hashMatch;
        return <Navigate to={`/${type}/${code}${queryParams}`}></Navigate>;
    }

    if (token) {
        return <Navigate to="/cad" replace></Navigate>
    }
    return <Navigate to="/signin" replace></Navigate>
}

function App() {
    // useMemo so this is set before render rather than after first render which a useEffect would do
    useMemo(() => {
        doRegistration();
        doPopoutRegistration();
        createEntities();
        pdfMake.fonts = {
            Roboto: {
                normal: 'dejavusans.ttf',
                bold: 'dejavusans-bold.ttf',
                italics: 'dejavusans-oblique.ttf',
                bolditalics: 'dejavusans-oblique.ttf'
            }
        };
    }, []);
    
    return (
        <Router basename={process.env.NODE_ENV === 'production' ? '/cra' : '/'}>
          <Routes>
            <Route element={<RootContext></RootContext>}>
                <Route path="/" element={<DefaultPath></DefaultPath>}></Route>
                <Route element={<SigninNavBar></SigninNavBar>}>
                    <Route path="/signin" element={<Signin imgUrl="/images/chronicler.png"></Signin>}></Route>
                </Route>
                <Route element={<RequireAuth></RequireAuth>}>
                    <Route path="/cad" element={<CAD></CAD>}></Route>
                    <Route path="/stats" element={<Stats></Stats>}></Route>
                    <Route path="/unity" element={<AngularRootApp key="unity" template="<unity-view></unity-view>"></AngularRootApp>}></Route>
                    <Route path="/settings" element={<Settings></Settings>}></Route>
                    <Route path="/sitrep" element={<SitRep></SitRep>}></Route>
                </Route>
                <Route element={<PublicNavBar></PublicNavBar>}>
                    <Route path="/publicform/:code" element={<PublicForm></PublicForm>}></Route>
                    <Route path="/forgottenPassword" element={<ReactForgottenPassword></ReactForgottenPassword>}></Route>
                    <Route path="/resetPassword" element={<ReactResetPassword></ReactResetPassword>}></Route>
                    <Route path="/requestAccount" element={<RequestAccount></RequestAccount>}></Route>
                    <Route path="/publicgroup/:code" element={<PublicFormGroup></PublicFormGroup>}></Route>
                </Route>
                <Route path="/logout" element={<Logout></Logout>}></Route>
                <Route path="/popout/:component" element={<Popout></Popout>}></Route>
            </Route>
          </Routes>
        </Router>
    );
}

export default App;